import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import ImageUploader from '../../../../common/ImageUploader';
import UserDocumentsPreview from '../../../../ProfileLayout/InsuranceDetails/UserDocumentsPreview';

import styles from './index.styl';

const DocumentsSection = ({ config, documents, onImageChange }) => {
  const { sectionTitle, fields } = config || {};

  const filteredDocuments = documents.filter(
    doc => doc.attachment && doc.attachment.url,
  );

  return (
    <Fragment>
      <div className={styles.title}>{sectionTitle}</div>
      <div className={styles.images}>
        {fields.map(field => {
          return (
            <ImageUploader
              {...field}
              key={field.fieldName}
              name={field.fieldName}
              maxFileSize={field.limit}
              onChange={val => {
                onImageChange(field.fieldName, val, field.id);
              }}
              errorTextClassName={styles.error}
            />
          );
        })}
      </div>
      <UserDocumentsPreview documents={filteredDocuments} />
    </Fragment>
  );
};

DocumentsSection.propTypes = {
  config: PropTypes.object.isRequired,
  documents: PropTypes.array.isRequired,
  onImageChange: PropTypes.func.isRequired,
};

export default DocumentsSection;



// WEBPACK FOOTER //
// ./src/components/forms/InsuranceForm/components/DocumentsSection/index.jsx